import { ChangeDetectorRef, Component } from '@angular/core';
import { CacheService } from '@shared/services/cache.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { HyperlinkService } from '@shared/services/hyperlink.service';
import { ItemsDirective } from '@shared/directives/items.directive';
import { IHyperlink, ITeaser } from '@shared/interfaces';
import { environment } from '../../../environments/default/environment';

@Component({
    selector: 'app-hyperlink',
    templateUrl: './hyperlink.component.html',
    styleUrls: ['./hyperlink.component.scss'],
    standalone: false
})
export class HyperlinkComponent extends ItemsDirective {
    env = environment;
    public teaserItems: { teaser: ITeaser; item: IHyperlink }[];

    public async loadData() {
        this.items = this.cache.hyperlinks
            ? this.cache.hyperlinks
            : this.cache.homeItems
              ? this.cache.homeItems.hyperlinks
              : [];
        super.loadData();
        this.items = this.cache.hyperlinks = await this.hyperlinkService.getAllItems();
        super.loadData();
    }

    constructor(
        changeDetection: ChangeDetectorRef,
        cache: CacheService,
        router: Router,
        translateService: TranslateService,
        private hyperlinkService: HyperlinkService
    ) {
        super(changeDetection, cache, router, translateService);
    }
}
